import React, { Fragment } from 'react'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'


type ProductCardHeadlineProps = {
  brand: string | ReactIntlMessage
  name: string | ReactIntlMessage
}

const ProductCardHeadline: React.FunctionComponent<ProductCardHeadlineProps> = ({ brand, name }) => (
  <Fragment>
    <Text
      message={brand}
      size="16-20"
      semibold
      dataTestId="productCardBrand"
    />
    <Box mt={4} noWrapper>
      <Text
        message={name}
        size="14-16"
        dataTestId="productCardName"
      />
    </Box>
  </Fragment>
)


export default React.memo(ProductCardHeadline)
